"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SelectTargetStateController;
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
function SelectTargetStateController($scope, $mdDialog, dashboardUtils, states) {

    var vm = this;
    vm.states = states;
    vm.stateId = dashboardUtils.getRootStateId(vm.states);

    vm.cancel = cancel;
    vm.save = save;

    function cancel() {
        $mdDialog.cancel();
    }

    function save() {
        $scope.theForm.$setPristine();
        $mdDialog.hide(vm.stateId);
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/states/select-target-state.controller.js